export const MAX_BUSINESS_DESCRIPTION_WORDS = 120;
export const MAX_T3_FIELD_WORDS = 25;
export const MAX_LOCATION_WORDS = 30;

export function countWords(value) {
    const trimmed = String(value ?? "").trim();
    if (!trimmed) return 0;
    return trimmed.split(/\s+/).filter(Boolean).length;
}

export function getWordLimitError(value, maxWords, fieldLabel) {
    const count = countWords(value);
    if (count <= maxWords) return null;
    return `${fieldLabel} must be ${maxWords} words or fewer (${count}/${maxWords})`;
}

export function isValidBusinessWebsite(value) {
    const trimmed = String(value ?? "").trim();
    if (!trimmed) return true;

    const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

    try {
        const url = new URL(candidate);
        if (!["http:", "https:"].includes(url.protocol)) return false;
        if (!url.hostname || !url.hostname.includes(".")) return false;
        if (url.hostname.endsWith(".")) return false;
        return true;
    } catch {
        return false;
    }
}

export function getBusinessWebsiteError(value) {
    if (isValidBusinessWebsite(value)) return null;
    return "Enter a valid website URL (e.g. https://example.com)";
}
